import {
  Input,
  Radio,
  RadioGroup,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  // Toast,
  useToast,
} from "@chakra-ui/react";
// import StatusTooltip from "./StatusTooltip";
// import { EditIcon, SearchIcon } from "@chakra-ui/icons";
import SearchModal from "../../DynamicTable/searchModal";
import Showinfo from "../../DynamicTable/Showinfo";
import { CustomCategorySelect } from "./CustomCategorySelect";

export const StepOneTable = ({
  skipColumns,
  headers,
  height,
  valuesForLot,
  dataReadyArray,
  enableEdit,
  binStatusData,
  setBinStatusData,
}) => {
  //   console.log(data, binStatusData);
  const toast = useToast();
  //   const [tableHeaders, setTableHeaders] = useState([]);
  const selectCategoryOpenOptions = [
    "LUMPS",
    "CHIPS",
    "COMP BQT",
    "BQT",
    "FBL",
    "COAL AN",
    "COKE CO",
    "COKE CH",
    "QRTZ",
    "BXT",
    "GCUT",
    "IRON ORE",
  ];
  // console.log(data, dataReadyArray);
  if (!skipColumns) {
    skipColumns = [];
  }

  const handleRadioChange = (value, idx) => {
    setBinStatusData((prev) => {
      let updatedData = {
        ...prev,
        [idx]: {
          ...prev[idx],
          type: value,
          min: value === "open" || value === "fixed" ? 20 : "",
          max: value === "open" || value === "fixed" ? 400 : "",
        },
      };
      return updatedData;
    });
  };
  const handleMinMaxChange = (value, idx, key) => {
    setBinStatusData((prev) => {
      let updatedData = {
        ...prev,
        [idx]: {
          ...prev[idx],
          [key]: value,
        },
      };
      return updatedData;
    });
  };
  const flexMap = {
    BIN: "10%",
    STATUS: "40%",
    "LOT NUMBER": "25%",
    CATEGORY: "25%",
  };

  const searchForCategory = (lotno, idx) => {
    console.log(lotno, idx, dataReadyArray, "SEARCHED");
    const foundObject = dataReadyArray.find((obj) => obj["lotno"] == lotno);
    const type = foundObject ? foundObject.type : undefined;
    if (type === "") {
      toast({
        title: "No Category ",
        position: "top-right",
        description: "Please add category in the ERP file",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } else {
      // console.log("search for categort", type, lotNumber);
    }

    return type;
  };

  const searchForAvailableQty = (lotno, idx) => {
    const foundObject = dataReadyArray.find((obj) => obj["lotno"] == lotno);
    const available_qnty = foundObject ? foundObject.available_qnty : null;
    if (
      available_qnty === "" ||
      available_qnty === null ||
      available_qnty === undefined
    ) {
      toast({
        title: "No Available quantity ",
        position: "top-right",
        description: "Please add Available quantity in the ERP file",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      return null;
    } else {
      // console.log("search for categort", type, lotNumber);
    }

    return available_qnty;
  };

  return (
    <TableContainer overflowY="auto" mt="1rem" maxH={height} w="100%">
      <Table size="sm">
        <Thead position="sticky" top="0" zIndex="sticky">
          <Tr bg="#1a174e">
            {headers?.map((elem, idx) => (
              <Th
                p="10px"
                key={idx}
                color="white"
                fontSize="15px"
                textTransform="none"
                fontWeight={400}
                w={flexMap[elem]}
                textAlign={elem == "CATEGORY" ? "left" : "Center"}
              >
                {elem}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {binStatusData &&
            Object.keys(binStatusData).length > 0 &&
            Object.keys(binStatusData)?.map((item, i) => (
              <Tr key={item} h={"55px"}>
                <Td className="!text-[#3E3C42] !text-center !text-[14px] !font-medium">
                  Bin {item}
                </Td>
                <Td>
                  {" "}
                  <RadioGroup
                    defaultValue={binStatusData[item]?.type}
                    onChange={(value) => handleRadioChange(value, item)}
                    isDisabled={!enableEdit}
                  >
                    <Stack direction="row" spacing={4} justify={"space-evenly"}>
                      <Radio
                        value="fixed"
                        colorScheme={
                          binStatusData[item]?.type === "fixed" ? "blue" : ""
                        }
                      >
                        <p
                          style={{
                            color: " #3E3C42",

                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "24px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          FIXED
                        </p>
                      </Radio>
                      <Radio
                        value="open"
                        colorScheme={
                          binStatusData[item]?.type === "open" ? "yellow" : ""
                        }
                      >
                        <p
                          style={{
                            color: " #3E3C42",

                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "24px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          OPEN
                        </p>
                      </Radio>
                      <Radio
                        value="not in use"
                        colorScheme={
                          binStatusData[item]?.type === "not in use"
                            ? "gray"
                            : ""
                        }
                      >
                        <p
                          style={{
                            color: " #3E3C42",

                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "24px",
                            letterSpacing: "0.5px",
                          }}
                        >
                          NOT IN USE
                        </p>
                      </Radio>
                    </Stack>
                  </RadioGroup>
                </Td>
                {binStatusData[item]?.type == "fixed" ? (
                  <>
                    <Td textAlign={"center"}>
                      {binStatusData[item]?.lotno ? (
                        <div className="flex gap-2 w-full justify-center">
                          {" "}
                          <p>{binStatusData[item]?.lotno}</p>
                          <SearchModal
                            lotNo={binStatusData[item]?.lotno}
                            bin={item}
                            valuesForLot={valuesForLot}
                            idx={item}
                            enableEdit={enableEdit}
                            setBinStatusData={setBinStatusData}
                          />
                        </div>
                      ) : (
                        <SearchModal
                          lotNo={binStatusData[item]?.lotno}
                          bin={item}
                          valuesForLot={valuesForLot}
                          idx={item}
                          enableEdit={enableEdit}
                          setBinStatusData={setBinStatusData}
                        />
                      )}
                    </Td>
                    <Td p={"8px"} textAlign={"center"} position={"relative"}>
                      <div className="flex gap-2 w-full">
                        <p className="min-w-[150px] text-left">
                          {binStatusData[item]?.lotno
                            ? searchForCategory(
                                binStatusData[item]?.lotno,
                                item
                              )
                            : ""}
                        </p>
                        {item?.lotNumber ? (
                          <Showinfo
                            dataReadyArray={dataReadyArray}
                            lotNumber={item.lotNumber}
                            bin={item.binName}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Td>
                    <Td p={"8px"} textAlign={"center"} position={"relative"}>
                      <div className="flex gap-2 w-full">
                        <p className="min-w-[150px] text-left">
                          {binStatusData[item]?.lotno
                            ? searchForAvailableQty(
                                binStatusData[item]?.lotno,
                                item
                              )
                            : ""}
                        </p>
                        {/* {item?.lotNumber ? (
                          <Showinfo
                            dataReadyArray={dataReadyArray}
                            lotNumber={item.lotNumber}
                            bin={item.binName}
                          />
                        ) : (
                          ""
                        )} */}
                      </div>
                    </Td>
                    <Td colSpan={1}>
                      <Input
                        value={binStatusData[item]?.min}
                        isDisabled={!enableEdit}
                        minW={"100px"}
                        size={"sm"}
                        rounded={"base"}
                        type="number"
                        min={20}
                        max={400}
                        onChange={(e) =>
                          handleMinMaxChange(e.target.value, item, "min")
                        }
                        onBlur={(e) => {
                          const value = e.target.value.trim(); // Trim whitespace for validation
                          if (value === "") {
                            handleMinMaxChange(20, item, "min"); // Default to 20 if input is empty
                          }
                        }}
                      />
                    </Td>
                    <Td colSpan={1}>
                      <Input
                        size={"sm"}
                        rounded={"base"}
                        value={binStatusData[item]?.max}
                        isDisabled={!enableEdit}
                        type="number"
                        min={20}
                        max={400}
                        onChange={(e) =>
                          handleMinMaxChange(e.target.value, item, "max")
                        }
                        onBlur={(e) => {
                          const value = e.target.value.trim(); // Trim whitespace for validation
                          if (value === "") {
                            handleMinMaxChange(400, item, "max"); // Default to 20 if input is empty
                          }
                        }}
                      />
                    </Td>
                  </>
                ) : binStatusData[item]?.type == "open" ? (
                  <>
                    <Td
                      textAlign={"Center"}
                      colSpan={1}
                      className="text-[#938F96] text-[14px]"
                    >
                      {"Optimizer will figure out the value"}
                    </Td>
                    <Td
                      textAlign={"Center"}
                      colSpan={1}
                      className="text-[#938F96] text-[14px]"
                    >
                      <CustomCategorySelect
                        value={binStatusData?.[item]?.category}
                        options={selectCategoryOpenOptions}
                        setBinStatusData={setBinStatusData}
                        idx={item}
                      />
                    </Td>
                    <Td
                      textAlign={"Center"}
                      colSpan={1}
                      className="text-[#938F96] text-[14px]"
                    ></Td>
                    <Td colSpan={1}>
                      <Input
                        size={"sm"}
                        rounded={"base"}
                        value={binStatusData[item]?.min}
                        isDisabled={!enableEdit}
                        type="number"
                        min={20}
                        max={400}
                        onChange={(e) => {
                          handleMinMaxChange(e.target.value, item, "min");
                        }}
                        onBlur={(e) => {
                          const value = e.target.value.trim(); // Trim whitespace for validation
                          if (value === "") {
                            handleMinMaxChange(20, item, "min"); // Default to 20 if input is empty
                          }
                        }}
                      />
                    </Td>
                    <Td colSpan={1}>
                      <Input
                        size={"sm"}
                        rounded={"base"}
                        value={binStatusData[item]?.max}
                        isDisabled={!enableEdit}
                        type="number"
                        min={20}
                        max={400}
                        onChange={(e) =>
                          handleMinMaxChange(e.target.value, item, "max")
                        }
                        onBlur={(e) => {
                          const value = e.target.value.trim(); // Trim whitespace for validation
                          if (value === "") {
                            handleMinMaxChange(400, item, "max"); // Default to 20 if input is empty
                          }
                        }}
                      />
                    </Td>
                  </>
                ) : (
                  <>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                  </>
                )}
              </Tr>
            ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
